import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Authentication uses a Secure, HttpOnly cookie set by the backend.
const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const prefix = `${name}=`;
  return document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length) || "";
};

export const adminHeaders = () => {
  const csrf = readCookie("vo_admin_csrf");
  return csrf ? { "X-CSRF-Token": decodeURIComponent(csrf) } : {};
};
